import React from "react";
import { Container, Row, Col } from "reactstrap";

const AuthFooter = props => {
  return (
    <>
      <footer className="py-5">
        <Container>
          <Row className="align-items-center justify-content-xl-between">
            <Col xl="12">
              <div className="copyright text-center text-xl-left">
                Copyright © 2021{" "}
                <a
                  className="font-weight-bold ml-1"
                  href="https://www.ghl.com/in-store/philippines"
                >
                  GHL Systems Philippines, Inc.
                </a>
                <br />
                All Rights Reserved.
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
}

export default AuthFooter;
